export default __webpack_public_path__ + "static/media/sam-and-karen-hiking-orcas.6f7df978.jpeg";